import $ from 'jquery';

import application from 'application/application';

const controller = 'DefaultVariationsVariationsDetailsController';

application

	.controller(controller, ['$scope', '$http', '$state', '$stateParams', 'API', 'helper', ($scope, $http, $state, $stateParams, API, helper) => {

		/** Instância de armazenamento de resposta. */
		$scope.variations = helper.responseStore()

			.setItemsPerPage(10);

		/** Define a página atual com base na URL. */

		if ($stateParams.paginaAtual !== undefined)

			$scope.variations.setCurrentPage($stateParams.paginaAtual);

		let

			/** Lista de filtros possíveis. */
			variationsFiltersNames = [
				'q',
				'visualizada',
				'favorita',
				'arquivada',
				'dataPublicacao',
				'idPalavraChave',
				'idDiario',
				'vara',
				'comarca'
			];

		/** Define os filtros informados na URL. */
		variationsFiltersNames.forEach(name => {

			let value = $stateParams[name];

			if (value !== undefined)

				$scope.variations.setFilter(name, value);

		});

		/** Define uma cópia dos filtros atuais para ser usados como modelo. */
		$scope.filtersVariations = helper.cloneSimpleObject($scope.variations.getFilters());

		/** Define valores padrões padrões para criar um item */
		const

			defaultVariations = {
				nome : '',
				ativo: true,
				aplicacoes: []
			};

		/** Cria item em vazio para ser preenchido. */
		$scope.emptyEmployeeProfile = helper.cloneSimpleObject(defaultVariations);

		/** Cria item em vazio para ser preenchido. */
		$scope.editableEmployeeProfile = {
			nome: '',
			ativo: '',
			aplicacoes: []
		};

		/**
		 * Recupera perfis.
		 *
		 * @param {ResponseStore} responseStore - Instância de armazenamento de resposta.
		 *
		 * @example
		 * // Cria uma instância de armazenamento de resposta.
		 * $scope.variations = helper.responseStore();
		 *
		 * // Recupera as aplicações.
		 * $scope.recordVariations($scope.variations);
		 */
		$scope.recordVariations = responseStore => {

			$http({
				...helper.http(API.userVariations, 'GET'),
				params: {
					...helper.httpFields([
						'id'
					]),
					paginaAtual: responseStore.getCurrentPage(),
					registrosPorPagina: responseStore.getItemsPerPage(),
					...responseStore.getFilters()
				}
			})

				.then(response => {

					responseStore.setItems(response.data.itens);

					$scope.variationsLength = response.data.paginacao.totalRegistros;

					$scope.variationsPagesLength = Math.ceil($scope.variationsLength / responseStore.getItemsPerPage());

				})

				.finally(() => responseStore.setReady(true));

		};

		$scope.recordVariations($scope.variations);

		/**
		 * Filtra os perfis de colaboradores.
		 *
		 * @param {Object} filters - Objeto com filtros.
		 */
		$scope.filterVariations = filters => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = 1;

			Object.keys(filters).forEach(filter => params[filter] = filters[filter]);

			$state.go($state.current.name, params, { inherit: false, reload: 'root.default.variations' });

		};

		/**
		 * Remove um filtro dos perfis de colaboradores.
		 *
		 * @param {String} filter - Filtro a ser removido.
		 */
		$scope.removeVariationsFilter = filter => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = 1;

			delete params[filter];

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 * Limpa os filtros dos perfis de colaboradores.
		 */
		$scope.clearVariationsFilters = () => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = 1;

			variationsFiltersNames.forEach(name => delete params[name]);

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 * Verifica se existe uma página anterior à atual.
		 */
		$scope.hasVariationsPrevPage = () => ($stateParams.paginaAtual ? +$stateParams.paginaAtual : 1) > 1;

		/**
		 * Navega para a primeira página.
		 */
		$scope.recordVariationsFirstPage = () => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = 1;

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 * Navega para a página anterior.
		 */
		$scope.recordVariationsPrevPage = () => {

			let params = helper.cloneSimpleObject($stateParams);

			let currentPage = params.paginaAtual ? Number(params.paginaAtual): 1;

			params.paginaAtual = currentPage > 1 ? currentPage - 1 : 1;

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 * Navega para a próxima página.
		 */
		$scope.recordVariationsNextPage = () => {

			let params = helper.cloneSimpleObject($stateParams);

			params.paginaAtual = params.paginaAtual ? Number(params.paginaAtual) + 1 : 2;

			$state.go($state.current.name, params, { inherit: false });

		};

		/**
		 *
		 */
		$scope.favoriteVariations = (responseStore, variations) => {

			if (!Array.isArray(variations)) variations = [ variations ];

			$http({
				...helper.http(API.variations, 'favorite'),
				method: 'PUT',
				data: {
					itens: variations
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(variations))

				.finally(() => responseStore.setItemsAsNotBusy(variations));

		};

		/**
		 *
		 */
		$scope.unfavoriteVariations = (responseStore, variations) => {

			if (!Array.isArray(variations)) variations = [ variations ];

			$http({
				...helper.http(API.variations, 'unfavorite'),
				method: 'PUT',
				data: {
					itens: variations
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(variations))

				.finally(() => responseStore.setItemsAsNotBusy(variations));

		};

		/**
		 *
		 */
		$scope.printVariations = variations => {

			if (!Array.isArray(variations)) variations = [ variations ];

			$state.go('root.default.variations.variationsDetails', {
				variationsIDs: variations.map(item => item.id).join(','),
				print: true
			});

		};

		/**
		 *
		 */
		$scope.downloadVariations = variations => {

			if (!Array.isArray(variations)) variations = [ variations ];

			window.open(helper.http(API.variations, 'download').url + '?IDs=' + variations.map(item => item.id).join(','), '_self');

		};

		/**
		 *
		 */
		$scope.archiveVariations = (responseStore, variations) => {

			if (!Array.isArray(variations)) variations = [ variations ];

			$http({
				...helper.http(API.variations, 'archive'),
				method: 'PUT',
				data: {
					itens: variations
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(variations))

				.finally(() => responseStore.setItemsAsNotBusy(variations));

		};

		/**
		 *
		 */
		$scope.restoreVariations = (responseStore, variations) => {

			if (!Array.isArray(variations)) variations = [ variations ];

			$http({
				...helper.http(API.variations, 'restore'),
				method: 'PUT',
				data: {
					itens: variations
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(variations))

				.finally(() => responseStore.setItemsAsNotBusy(variations));

		};

		/**
		 *
		 */
		$scope.forwardVariations = (responseStore, variations) => {

			if (!Array.isArray(variations)) variations = [ variations ];

			$http({
				...helper.http(API.variations, 'forward'),
				method: 'POST',
				data: {
					itens: variations
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(variations))

				.finally(() => responseStore.setItemsAsNotBusy(variations));

		};

		/**
		 *
		 */
		$scope.setVariationsAsRead = (responseStore, variations) => {

			if (!Array.isArray(variations)) variations = [ variations ];

			$http({
				...helper.http(API.variations, 'setAsRead'),
				method: 'PUT',
				data: {
					itens: variations
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(variations))

				.finally(() => responseStore.setItemsAsNotBusy(variations));

		};

		/**
		 *
		 */
		$scope.setVariationsAsUnread = (responseStore, variations) => {

			if (!Array.isArray(variations)) variations = [ variations ];

			$http({
				...helper.http(API.variations, 'setAsUnread'),
				method: 'PUT',
				data: {
					itens: variations
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'), () => responseStore.rowbackItems(variations))

				.finally(() => responseStore.setItemsAsNotBusy(variations));

		};

		/**
		 * Atualiza uma ou mais aplicações.
		 *
		 * @param {ResponseStore} responseStore - Instância de armazenamento de resposta.
		 * @param {Object[]|Object} items - Aplicação(ões) a ser(em) atualizada(s).
		 *
		 * @example
		 * // Cria uma instância de armazenamento de resposta.
		 * $scope.variations = helper.responseStore();
		 *
		 * // Atualiza o valor `foo` da aplicação de ID 0.
		 * $scope.updateVariations($scope.variations, {id: 0, foo: true});
		 *
		 * // Atualiza o valor `foo` das aplicações de ID's 0 e 1.
		 * $scope.updateVariations($scope.variations, [{id: 0, foo: true}, {id: 1, foo: true}]);
		 */
		$scope.updateVariations = (responseStore, items) => {

			responseStore.setItemsAsBusy(items);

			$('.modal').modal('hide');

			/** Caso `items` seja um unico item, cria um `Array` para ele. */
			if (!Array.isArray(items)) items = [ items ];

			$http({
				...helper.http(API.variations, 'PUT'),
				data: {
					itens: items
				}
			})

				.then(response => responseStore.updateItems(response.data.itens, true, 'id'))

				.finally(() => responseStore.setItemsAsNotBusy(items));

		};

		/** Exibe o modal para edição de aplicação. */
		$scope.showEmployeeProfilesModal = (responseStore, item, id) => {

			const

				showModal = () => {

					$('#' + id)

						.modal('show')

						.off('hidden.bs.modal')

						.on('hidden.bs.modal', () => {

							responseStore

								.rowbackItems(item)

								.setItemAsNotEditable(item);

							if (!$scope.$$phase) $scope.$apply();

						});

				};

			responseStore

				.setItemAsEditable(item)

				.setSiblingItemsAsNotEditable(item);

			$scope.editableEmployeeProfile = responseStore.getItems().find(value => value.__editable__);

			if (!item.aplicacoes)

				$scope.recordEmployeeProfileDetails(responseStore, item, showModal);

			else showModal();

		};

		/***************************************************************/

		$http({
			...helper.http(API.userVariations, 'GET'),
			params: {
				...helper.httpFields([
					'id',
					'palavraChave'
				])
			}
		})

			.then(response => $scope.userVariations = response.data.itens);

		/***************************************************************/

		$http({
			...helper.http(API.userDiaries, 'GET'),
			params: {
				...helper.httpFields([
					'id',
					'diario'
				])
			}
		})

			.then(response => $scope.userDiaries = response.data.itens);

		/***************************************************************/

	}]);

export default controller;
